import React from 'react'
import Carousal from './Carousal'
import About from './About'
import Section from './Section'
import Services from './Services'
import Footer from './Footer'



const Home = () => {
  return (
    <div>
      <Carousal />
      <About />
      <Section />
      <Services />
    
      <Footer />

    </div>
  )
}

export default Home